import validateString from "../../../../../utils/validate/validateString";

export const validateUsernames = (value: string): string => {
  return validateString(value, { isReq: true, min: 3 });
};
